export default "__VITE_ASSET__1010e4da__"